/**
 * 將欄位文字中的 {{$key}} 替換為對應資料值
 * @param {string} text
 * @param {(key: string) => *} getValue
 * @returns {string}
 */
export function resolveFieldText(text, getValue) {
  if (!text) return "";

  return text.replace(/\{\{\$(\w+)\}\}/g, (_, key) => {
    const value = getValue(key);
    return value != null ? value : "";
  });
}
